import { toast, useLocalization } from '@magicdoorinc/ui';

const { t } = useLocalization();

export function handleFormValidation(noChangesMessage?: string): void {
  toast.error(noChangesMessage ?? t('No changes to update'));
}
